import { service } from '@/ajax/request';

export const consultationOrganList = () => (
    service({
        url: '/fdm-consultation-symptom/fiveVisceraList',
        method: 'POST',
    })
)

export const editFiveViscera = (params: any) => (
    service({
        url: '/fdm-consultation-symptom/editFiveVisceraList',
        method: 'POST',
        params
    })
)

export const getConsultationList = (params: any) => (
    service({
        url: '/fdm-consultation-symptom/consultationSymptomPage',
        method: 'POST',
        params
    })
)

export const getTenConsultationList = (params: any = {}) => (
    service({
        url: '/fdm-consultation-symptom/fdmTenConsultationList',
        method: 'POST',
        params
    })
)

export const saveConsultation = (params: any = {}) => (
    service({
        url: '/fdm-consultation-symptom/saveOrUpdate',
        method: 'POST',
        params
    })
)

export const updateFdmStatus = (params: any = {}) => (
    service({
        url: '/fdm-consultation-symptom/updateFdmStatus',
        method: 'POST',
        params
    })
)

export const getPulseTongueRelation = (params: any = {}) => (
    service({
        url: '/fdm-pulse-tongue-relation/getPulseTongueRelation',
        method: 'POST',
        params
    })
)

export const getPulseList = (params: any = {}) => (
    service({
        url: '/fdm-pulse-tongue-relation/findPulseList',
        method: 'POST',
        params
    })
)

export const editPulseTongueRelation = (params: any = {}) => (
    service({
        url: '/fdm-pulse-tongue-relation/editPulseTongueRelation',
        method: 'POST',
        params
    })
)

export const anxietySyndromesList = (params: any = {}) => (
    service({
        url: '/fdm-anxiety-syndromes/anxietySyndromesList',
        method: 'POST',
        params
    })
)

export const editAnxietySyndromesList = (params: any = {}) => (
    service({
        url: '/fdm-anxiety-syndromes/editAnxietySyndromesList',
        method: 'POST',
        params
    })
)

export const fdmMedicinalList = (params: any = {}) => (
    service({
        url: '/fdm-medicinal-fragrance/get-page',
        method: 'POST',
        params
    })
)

export const fdmMedicinalListEdit = (params: any = {}) => (
    service({
        url: '/fdm-medicinal-fragrance/save-or-update',
        method: 'POST',
        params
    })
)

export const fdmMedicinalListStatus = (params: any = {}) => (
    service({
        url: '/fdm-medicinal-fragrance/status',
        method: 'POST',
        params
    })
)

export const fdmNurseList = (params: any = {}) => (
    service({
        url: '/fdm-nurse/get-page',
        method: 'POST',
        params
    })
)

export const fdmNurseSymptomList = (params: any = {}) => (
    service({
        url: '/fdm-nurse/get-symptom-list',
        method: 'POST',
        params
    })
)
export const fdmNurseRuleList = (params: any = {}) => (
    service({
        url: '/fdm-nurse/get-rule-list',
        method: 'POST',
        params
    })
)
export const fdmNurseMedicinalList = (params: any = {}) => (
    service({
        url: '/fdm-nurse/medicinal-list',
        method: 'POST',
        params
    })
)

export const fdmNurseSymptomOptionList = (params: any = {}) => (
    service({
        url: '/fdm-nurse/get-symptom-list',
        method: 'POST',
        params
    })
)
export const fdmNurseEdit = (params: any = {}) => (
    service({
        url: '/fdm-nurse/save-or-update',
        method: 'POST',
        params
    })
)

export const fdmNurseStatus= (params: any = {}) => (
    service({
        url: '/fdm-nurse/status',
        method: 'POST',
        params
    })
)

